export default function makeAddBtn({ addBtn, events, action }) {
    let initialized = false;
    return Object.freeze({
        init
    });
    function init() {
        if (initialized)
            return;
        initialized = true;
        _addListeners();
    }
    function _addListeners() {
        addBtn.addEventListener('click', (e) => {
            events.emit(action);
        });
    }
}
